import { ContentfulMedia, ContentfulRichText } from '@wbk/contentful';
import { Typography } from '@wbk/ui';

import HeroTitle from '@/components/ui/HeroTitle';
import type { ContentfulEvent } from '@wbk/contentful/api';

type Props = {
  event: ContentfulEvent;
};

const EventHeroRS = ({ event: section }: Props) => {
  if (!section) return null;
  return (
    <section>
      <div className='from-body/60 to-body relative flex min-h-dvh flex-col justify-center from-10% via-transparent via-30% before:absolute before:inset-0 before:-z-10 before:bg-gradient-to-b after:absolute after:inset-0 after:-z-10 after:bg-black/30 lg:justify-end after:lg:bg-transparent'>
        <div className='absolute inset-0 -z-10 bg-gradient-to-b from-transparent via-black/40 to-black/80 mix-blend-multiply' />
        {section.image32 ? (
          <ContentfulMedia
            media={section.image32}
            className='absolute -z-20 h-full w-full object-cover object-top'
            autoPlay
            muted
            loop
            playsInline
          />
        ) : section.image31 ? (
          <ContentfulMedia
            media={section.image31}
            className='absolute -z-20 h-full w-full object-cover object-top'
            autoPlay
            muted
            loop
            playsInline
          />
        ) : section.image11 ? (
          <ContentfulMedia
            media={section.image11}
            className='absolute -z-20 h-full w-full object-cover object-top'
          />
        ) : null}

        <div className='container absolute inset-x-0 bottom-40 flex flex-col gap-4 px-8 sm:bottom-60 sm:justify-between md:flex-row md:items-end lg:bottom-28 lg:px-12 2xl:px-20'>
          <div className='flex flex-1 flex-col gap-2'>
            <div className='flex flex-1 flex-col gap-2 xl:max-w-xl'>
              <Typography as='p' variant='body-M' className='text-body-L font-semibold'>
                {section?.category?.title}
              </Typography>

              <HeroTitle title={section?.title || ''} className='line-clamp-3 uppercase' />
            </div>
          </div>

          <div className='flex flex-[0.8] flex-col gap-4'>
            <Typography variant='body-S' className='md:text-body-M uppercase text-white/80'>
              {section.subtitle && `${section.subtitle}!`}
            </Typography>
            {section.description && (
              <Typography
                as='div'
                variant='body-S'
                className='xl:text-body-M 2xl:text-body-L line-clamp-3 text-white/80'
              >
                <ContentfulRichText description={section.description} />
              </Typography>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventHeroRS;
